import { useContext, useState, useEffect } from "react";
import { Formik } from "formik";
import { Container } from "@certn/cascadia-react";

import { PackageStepLayout } from "../PackageStepLayout";
import { PackageContext } from "../../PackageContext";
import { PackageATSConfiguration } from "../../../PackageATSConfiguration";

export function ATSConfigurationStep() {
  const { packageData, setPackage, goToNextStep } = useContext(PackageContext);
  const [validateJsonForm, setValidateJsonForm] = useState(false);

  useEffect(() => {
    setValidateJsonForm(false);
  }, []);

  return (
    <Formik
      initialValues={{
        clientFormDataAndErrors: {
          data: packageData.client_input_claims || {},
          errors: [],
        },
      }}
      onSubmit={(values) => {
        const updatedPackage = {
          ...packageData,
          client_input_claims: values.clientFormDataAndErrors?.data || {},
        };
        setPackage(updatedPackage);
        goToNextStep();
      }}
    >
      {({ handleSubmit, isSubmitting }) => {
        return (
          <PackageStepLayout
            onComplete={() => {
              setValidateJsonForm(true);
              handleSubmit();
            }}
            submitting={isSubmitting}
          >
            <Container layout="narrow">
              <PackageATSConfiguration
                packageData={packageData}
                isSubmitted={validateJsonForm}
                titleAs="h1"
              />
            </Container>
          </PackageStepLayout>
        );
      }}
    </Formik>
  );
}
